import React, { useRef, useState, useEffect, forwardRef } from 'react';
import { Modal } from 'react-bootstrap';
import { FaSave, FaTimes } from 'react-icons/fa';
import { API_URL_All } from '../../api';
import { toast } from "react-toastify";
import * as general from '../../libs/general';
import axiosInstance from '../../axiosInstance';

const TransferCustomerEditor = ({ data, handleSearch, handleClose }) => {
  const canSubmitTransfer = data?.canSubmitTransfer === true;
  const [show, setShow] = useState(true);
  const [model, setModel] = useState({});
  const transferKey = data?.pendingUserId
    ? `pendingUser:${data.pendingUserId}`
    : data?.readBatchId
      ? `readBatch:${data.readBatchId}`
      : data?.requesterId
      ? `requester:${data.requesterId}`
      : `orders:${(data?.listIds || []).join(';')}`;

  useEffect(() => {
    initializeData(data);
  }, [transferKey]);

  const clearUrlParam = () => {
    const hash = window.location.hash;

    if (hash.includes('?')) {
      const cleanHash = hash.split('?')[0];
      const newUrl = window.location.origin + window.location.pathname + cleanHash;
      window.history.replaceState(null, '', newUrl);
    }
  }
  const handleModalClose = (e) => {
    document.querySelectorAll('.show .error-msg').forEach((item) => {
      if (item.parentNode) {
        item.parentNode.removeChild(item);
      }
    });
    document.activeElement.blur();
    clearUrlParam();
    window.dispatchEvent(new Event('refresh-operation-info'));
    setShow(false);
    if (handleClose) handleClose();
  };

  const handleSubmitForm = async(e) => {
    e.preventDefault();
    if (!canSubmitTransfer) return;
    var errorTag = e.currentTarget.querySelector('.error-msg');
    if (errorTag) return;

    var dataModel = { ...model };

    try {
      var requestApi = `/api/import-orders/transferCustomerCode`;
      const response = await axiosInstance.post(requestApi, dataModel);
      if (!response.data.success) {
        general.showFormError('.show .modal-body', response.data);
        console.log(response.data);
        return;
      }
      console.log(response);
      toast.success(response.data.message);
      if (response.data.warning) {
        toast.warning(response.data.warning, { autoClose: 15000 });
      }
      if (handleSearch) handleSearch();
      handleModalClose();
      
    } catch (error) {
      toast.error(error.message);
    }

  };

  const initializeData = async (obj) => {
    var orderId = obj.id;
    const isNumber = Number.isFinite(orderId);
    if (!isNumber) {
      orderId = 0;
    }

    const idsText = (obj.listIds || []).join(';');
    var urlApi = `/api/import-orders/searchTransferOrders?orderIds=${idsText}`;
    if (obj.pendingUserId) {
      urlApi = `/api/import-orders/searchTransferOrders?pendingUserId=${obj.pendingUserId}`;
    } else if (obj.readBatchId) {
      urlApi = `/api/import-orders/searchTransferOrders?readBatchId=${obj.readBatchId}`;
    } else if (obj.requesterId) {
      urlApi = `/api/import-orders/searchTransferOrders?requesterId=${obj.requesterId}`;
    }

    setModel({});
    try {
      var response = await axiosInstance.get(urlApi);
      var obj = response.data;

      setModel(obj);
      setShow(true);
    } catch (error) {
      console.error(error);
      toast.error(error.message);
    }
  };

  const handleFormSubmit = (e) => {
    if (!canSubmitTransfer) {
      e.preventDefault();
      return;
    }
    handleSubmitForm(e);
  };

  return (
    <Modal show={show} onHide={handleModalClose} size="lg">
      <div className="">
        <form id="order_editor_form" className="form_validate normal-form" autoComplete="off" onSubmit={handleFormSubmit}>
          <div className="modal-content">
            <div className="modal-header position-relative flex-between">
              {model.orderCode && (<span className="record_id">Code: {model.orderCode}</span>)}
              <div>
                <h5 className="modal-title">Chi tiết yêu cầu chuyển đơn</h5>
                {model.error && (
                  <div className="error-msg-server">{model.error}</div>
                )}
              </div>
              <button
                type="button"
                className="btn-close"
                onClick={handleModalClose}
                aria-label="Đóng"
              ></button>
            </div>
            <div className="modal-body mt-2">

              <div className="row">
                <div className="col-md-8 mb-3">

                  <div className="group-box p-0" data-text="Danh sách đơn hàng">


                    <section className="p-1 pt-4">
                      <div className="table-responsive border table-normal table-sticky">
                        <table className="table table-striped border-normal table-bordered">
                          <thead className="table-primary head-01">
                            <tr>
                              <th className='sticky text-center' width="21px"></th>

                              <th className="text-center"><span>Ngày</span></th>
                              <th className="text-center">Mã vận đơn TQ</th>
                              <th className="text-center"><span>Mã Khách hàng</span></th>
                              <th>Tên đơn hàng</th>

                            </tr>
                          </thead>
                          {model.page && model.page.content && model.page.content.map((item, index) => (
                            <tbody className="tbody-row">
                              <tr key={index}>
                                <td className='sticky text-center' title={`orderCode: ${item.orderCode}`}>
                                  {index + 1}
                                </td>
                                <td className="text-success text-center" title={item.lineName}>{general.formatDate2(item.createdDate)}</td>
                                <td className="text-success text-center">{item.cnShippingCode}</td>
                                <td className='text-success text-center'>{item.customerCode}</td>
                                <td className="text-success text-start">{item.name}</td>

                              </tr>
                            </tbody>
                          ))}

                        </table>
                      </div>
                    </section>
                  </div>

                </div>
                <div className="col-md-4 mb-3">
                  {model.parent && (

                    <div>
                      <span>Yêu cầu từ: <b>{model.parent.name} - {model.parent.customerCode}</b></span><br />
                      <span>Số đơn hàng: {model.parent.orderCount}</span><br />
                      {model.parent.requestCount > 1 && (
                        <span>Số lần gửi: {model.parent.requestCount}<br /></span>
                      )}
                      <span>Thời gian {general.formatDateTime2(model.parent.createdAt)}</span>
                      <br /><br />
                    </div>

                  )}
                  <div>
                    <label className={canSubmitTransfer ? 'form-label required' : 'form-label'}>Mã khách hàng</label>
                    <div className="th filter-editor">
                      <span className="filter-ib" data-source-url={API_URL_All + '/api/users/searchUserCodes'}>
                        <input
                          type="text"
                          name="customerCode"
                          placeholder="Nhập mã khách hàng..."
                          {...(canSubmitTransfer ? { 'data-required': 'Phải nhập mục này.' } : {})}
                          readOnly={!canSubmitTransfer}
                          value={model.customerCode ?? ''}
                          onChange={(e) => setModel({ ...model, customerCode: e.target.value })}
                        />
                      </span>
                    </div>
                  </div>
                </div>


              </div>


            </div>
            <div className="modal-footer justify-content-end gap-2">
              {canSubmitTransfer ? (
                <button type="submit" className="btn btn-sm btn-primary d-inline-flex align-items-center gap-2">
                  <FaSave aria-hidden />
                  Cập nhật
                </button>
              ) : (
                <button
                  type="button"
                  className="btn btn-sm btn-secondary d-inline-flex align-items-center gap-2"
                  onClick={handleModalClose}
                >
                  <FaTimes aria-hidden />
                  Đóng
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default TransferCustomerEditor;
